/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const BreakTimeInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 300}}>
          <h3>法定休息時間</h3>
          <P>勞工工作四小時，至少應有三十分鐘之休息。</P>
        </section>
      }
    />
  );
};

export default BreakTimeInfo;
